const base = 64;

export const calculatePrefixForExercise = (exerciseId, supersets) => {
  if (supersets) {
    const found = supersets.findIndex((superset) => {
      return superset.find((ex) => ex === exerciseId);
    });
    if (found >= 0) {
      const internalFound = supersets[found].findIndex(
        (ex) => ex === exerciseId
      );
      const code = found + 1 + base;
      const subcode =
        internalFound >= 0 && supersets[found].length > 1
          ? internalFound + 1
          : "";
      return String.fromCharCode(code) + subcode;
    }
  }

  return "";
};

/**
 * Build the superset data structure. It's an array of arrays containing the exercise ids
 * in the following way
 * [
 *    ['id1', 'id2', 'id3'],  => supertset 1
 *    ['id4'], => no superset, single exercise
 *    ['id5', 'id6'],  => supertset 2
 *    ['id7'], => no superset, single exercise
 * ]
 *
 *
 */
export const buildSupersets = (exercises) => {
  const supersets = [];
  exercises &&
    exercises.map((exercise, exerciseIndex) => {
      const previousExercise = exerciseIndex && exercises[exerciseIndex - 1];
      if (
        !previousExercise ||
        !previousExercise.nextSuperset ||
        previousExercise.nextSuperset !== exercise._id
      ) {
        supersets.push([exercise._id]);
      }
      if (previousExercise && previousExercise.nextSuperset === exercise._id) {
        const prevSuperset = supersets[supersets.length - 1];
        prevSuperset.push(exercise._id);
      }
    });

  return supersets;
};
